import {Component, ElementRef, forwardRef, HostBinding, Input, ViewChild} from '@angular/core';
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, Validators} from '@angular/forms';
import {BehaviorSubject} from 'rxjs';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {debounceTime} from 'rxjs/operators';

@Component({
  selector: 'app-credentials-select',
  templateUrl: './credentials-select.component.html',
  styleUrls: ['./credentials-select.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CredentialsSelectComponent),
    multi: true
  }]
})
export class CredentialsSelectComponent implements ControlValueAccessor {
  @Input() showMessage = true;
  public credentialsList = [
    'AAOPT',
    'AAS',
    'AAS OTA',
    'ACHP-SW',
    'ACNP',
    'ACNP-BC',
    'ACS',
    'ACSW',
    'AD',
    'AGNP-BC',
    'AIA',
    'ANCC',
    'AND',
    'ANP',
    'ANP-BC',
    'AP',
    'APA',
    'APA-C',
    'APN',
    'APN-C',
    'APN-FNP',
    'APNP',
    'APRN',
    'ARNP',
    'ARNP-C',
    'ASCLS',
    'ASMLS',
    'ASN',
    'ASPRS',
    'ASRT',
    'ASW-G',
    'ATC',
    'AuD',
    'AVP',
    'BA',
    'BASW',
    'BC',
    'BCS-S',
    'BDS',
    'BELS',
    'BHS',
    'BS',
    'BSCLS',
    'BSMLS',
    'BSMT',
    'BSN',
    'BSPT',
    'BSRN',
    'BSRT',
    'BSW',
    'C/NDT',
    'CAATE',
    'CAE',
    'CAN',
    'CANS',
    'CAPA',
    'CASC',
    'C-ASWCM',
    'C-CATODSW',
    'CCC',
    'CCC-SLP',
    'CCC-SLP/L',
    'CCMA',
    'CCRN',
    'CCRP',
    'CDIS',
    'CEES',
    'CEN',
    'CENP',
    'CFA',
    'CFNP',
    'CFPS',
    'CGP',
    'CGRN',
    'CHC',
    'CHP-SW',
    'CHT',
    'CIC',
    'CIMT',
    'CLNC',
    'CLT',
    'CMA',
    'CMAA',
    'CMA-A',
    'CMA-AC',
    'CMA-C',
    'CMM',
    'CMPE',
    'CN',
    'CNM',
    'CNO',
    'CNOR',
    'CNP',
    'CNR',
    'CNS',
    'CNSC',
    'CNT',
    'CNW',
    'COA',
    'COT',
    'COTA',
    'COTA-L',
    'CP',
    'CPA',
    'CPAN',
    'CPC',
    'CPC-A',
    'CPC-CMA',
    'CPCO',
    'CPCS',
    'CPHQ',
    'CPHRM',
    'CPhT',
    'CPMA',
    'CPNP',
    'CPSN',
    'CRA',
    'CRHP',
    'CRLA',
    'CRNA',
    'CRND',
    'CRNFA',
    'CRNO',
    'CRNP',
    'CRRN',
    'CRT',
    'CSCS',
    'CSFA',
    'C-SSWS',
    'CST',
    'CSW',
    'C-SWCM',
    'CSW-G',
    'C-SWHC',
    'CTS',
    'CVA',
    'CVN',
    'DC',
    'DCSW',
    'DDS',
    'DHSC',
    'DMD',
    'DMSc',
    'DNAP',
    'DNP',
    'DNP-C',
    'DNS',
    'DO',
    'DON',
    'DPM',
    'DPT',
    'DrPH',
    'DSCLS',
    'DVP',
    'EdD',
    'EMB (ACE)',
    'EMT-B',
    'EMT-I',
    'EMT-I/89',
    'EMT-IV',
    'Eng',
    'ENT-I/99',
    'FA',
    'FAAD',
    'FAAEM',
    'FAAFP',
    'FAAN',
    'FAAPD',
    'FAAPMR',
    'FACC',
    'FACCP',
    'FACE',
    'FACEP',
    'FACFAS',
    'FACG',
    'FACMPE',
    'FACOG',
    'FACOS',
    'FACP',
    'FACS',
    'FADSA',
    'FASGE',
    'FASPS',
    'FCAP',
    'FCCM',
    'FHFMA',
    'FHM',
    'FICS',
    'FNP',
    'F-NP',
    'FNP-BC',
    'FNPC',
    'FNP-C',
    'FRCPC',
    'FRCS(C)',
    'FSCAI',
    'FSTS',
    'G',
    'GA',
    'GCS',
    'GNP',
    'HCM',
    'HCRM',
    'HR',
    'IRDO',
    'IRN',
    'JD',
    'JR',
    'LAT',
    'LCSW',
    'LD',
    'LHRM',
    'LISW',
    'LLC',
    'LLP',
    'LMP',
    'LMSW',
    'LNHA',
    'LP',
    'LPA',
    'LPC',
    'LPN',
    'LPT',
    'LPTA',
    'LSCW',
    'LSH',
    'LSP',
    'LSW',
    'LTD',
    'LVN',
    'MA',
    'MAOM',
    'MAT',
    'MBA',
    'MBBS',
    'MD',
    'MGR',
    'MHA',
    'MHNP',
    'MHS',
    'MHSA',
    'MI',
    'MLS',
    'MLT',
    'MMS',
    'MMT',
    'MN',
    'MOA',
    'MOT',
    'MOTR/C',
    'MPA',
    'MPAS',
    'MPH',
    'MPT',
    'MS',
    'MSA',
    'MSAT',
    'MSc',
    'MSHI',
    'MSH-L',
    'MSHSA',
    'MSHS-C',
    'MSIT',
    'MSM',
    'MSMLS',
    'MSN',
    'MSOD',
    'MS-OTR',
    'MSPT',
    'MSRT',
    'MSW',
    'MT-BC',
    'MURAT',
    'NCMP',
    'ND',
    'NEA-BC',
    'NE-BC',
    'NHA',
    'NJ',
    'NNP',
    'NP',
    'NPBC',
    'NP-BC',
    'NPC',
    'NP-C',
    'NRAEMT',
    'NREMT',
    'NRMA',
    'NRP',
    'NSCLS',
    'OCN',
    'OD',
    'OM',
    'OPT',
    'OT',
    'OT/L',
    'OTA',
    'OTA/L',
    'OTD',
    'OTLR',
    'OTR',
    'OTR/L',
    'OTRL',
    'OTRL/L',
    'PA',
    'PA-C',
    'PC',
    'PE',
    'PharmD',
    'PhD',
    'PHN',
    'PHR',
    'PLLC',
    'PM',
    'PMP',
    'PN',
    'PRN',
    'PS',
    'PSA',
    'PSC',
    'PSR',
    'PsyD',
    'Psy-D',
    'PT',
    'PTA',
    'QCSW',
    'RAC-CT',
    'RD',
    'RDA',
    'RDH',
    'RDMS',
    'RDN',
    'RDO',
    'RHIA',
    'RMA',
    'RN',
    'RN-BC',
    'RNBSN',
    'RNC',
    'RN-CURN',
    'RNFA',
    'RNP',
    'RPA',
    'RPA-C',
    'R-PAC',
    'RPh',
    'RPT',
    'RQM',
    'RRT',
    'RRTE',
    'RT',
    'RVP',
    'RVT',
    'S LP',
    'S TR',
    'SA',
    'SEN',
    'SLP',
    'SLP-A',
    'SLP-CCC',
    'SLP-CFY',
    'SLP-I',
    'SP',
    'SPA',
    'SPL',
    'SR',
    'ST',
    'STA',
    'STP',
    'SW',
    'SW-G',
    'TP',
    'TR',
    'VA',
    'VT',
    'WHNP',
    'WHNP-BC'
  ];
  public filteredCredentialsList: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
  @Input() public placeholder: string;
  @HostBinding('class.disabled') public disable: boolean = null;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  credentialsControl = new FormControl();
  credentials: string[] = [];
  @ViewChild('credentialsInput') credentialsInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  @HostBinding('class.credentials-select') credentialsClass = true;

  constructor() {
    this.filteredCredentialsList.next(this.credentialsList.sort((a, b) => a.localeCompare(b)));
    this.credentialsControl.valueChanges.pipe(
      debounceTime(100)
    ).subscribe(value => {
      const res = value && value.length > 0 ? this.credentialsList.filter(it => it.toLowerCase().startsWith(value.toLowerCase())) : this.credentialsList;
      this.filteredCredentialsList.next(res);
    });
  }

  public get value() {
    return this.credentials;
  }

  @Input()
  public set value(value: string[]) {
    if (value) {
      value = [...new Set(value)];
      this.credentials = value;
      this.credentials.forEach((item) => this.removeFilteredCredentialsList(item));
    }
    this.onChange(value);
    this.onTouch(value);
  }

  remove(fruit: string): void {
    const index = this.credentials.indexOf(fruit);

    if (index >= 0) {
      this.credentials.splice(index, 1);
      this.value = this.credentials.slice();

      const filteredArr: any[] = this.filteredCredentialsList.getValue();
      filteredArr.push(fruit);
      filteredArr.sort((a, b) => a.localeCompare(b));

      this.filteredCredentialsList.next(filteredArr);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.credentials.push(event.option.viewValue);
    this.credentialsInput.nativeElement.value = '';
    this.credentialsControl.setValue(null);
    this.value = this.credentials.slice();
  }

  removeFilteredCredentialsList(data: any) {
    const filteredCredentialsArr: any[] = this.filteredCredentialsList.getValue();

    filteredCredentialsArr.forEach((item, index) => {
      if (item === data) { filteredCredentialsArr.splice(index, 1); }
    });

    this.filteredCredentialsList.next(filteredCredentialsArr);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disable = isDisabled;
  }

  writeValue(obj: string[]): void {
    this.value = obj;
  }

  private onChange: (value: string[]) => void = () => {
  }

  private onTouch: (value: string[]) => void = () => {
  }
}
